import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  pieAnimationMorph,
  backgroundColor,
  color,
  datasetXY,
  datasetPivot,
  initPie,
  pieAnimation,
  pieGeometry,
  initPivot,
  discreteLegend,
  pivotAdapter,
  pivotColumnDimensions,
  pivotGridStyle,
  pivotIndicators,
  pivotIndicatorsAsRow,
  pivotDiscreteLegend,
  pivotRowDimensions,
  tooltip,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  progressive,
  pieStyle,
  pieHover,
  colorPieStyleFill,
  linearColor,
  colorAdapter,
  colorLegend,
  pivotColorLegend,
  labelPie,
  pivotHideIndicatorName,
  pivotTitle,
  addRegionPadding,
  brush,
  dimensionLinkage,
  fontFamilyTheme,
} from '../pipes'

const pie: VChartSpecPipeline = [
  fontFamilyTheme,
  initPie,
  pieAnimation,
  pieGeometry,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetXY,
  pieAnimationMorph,
  progressive,
  brush,
  colorPieStyleFill(pieStyle),
  pieHover,
  colorAdapter(discreteLegend, colorLegend),
  labelPie,
  tooltip({ titleEncoding: 'color' }),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
]

const pivotPie: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  pivotHideIndicatorName,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initPie,
    pieAnimation,
    pieGeometry,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetXY,
    pieAnimationMorph,
    progressive,
    brush,
    colorPieStyleFill(pieStyle),
    pieHover,
    labelPie,
    tooltip({ titleEncoding: 'color' }),
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationArea,
    addRegionPadding,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const pieSpecPipeline = [pivotAdapter(pie, pivotPie)]
